<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'GroupInfoList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Group Info
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Group Info</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="GroupInfo">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra Name</label>
                    <input
                      v-if="is_edit"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      name="accountId"
                      class="form-control accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Group Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      v-bind:class="{ 'has-error': errors.has('name') }"
                      :readonly="is_edit && value.user_defined == 'NO'"
                      v-validate="'required'"
                      v-model="value.name"
                      class="form-control name"
                      placeholder="Name"
                    />
                    <div class="help text-danger" v-show="errors.has('name')">
                      {{ errors.first("name") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Group Icon</label>
                    <div class="group-image-list">
                      <label
                        v-for="(imageUrl, imageKey) in pre.groupImages"
                        :key="imageKey"
                      >
                        <input
                          type="radio"
                          name="groupImage"
                          :value="imageKey"
                          v-model="value.group_img"
                        />
                        <div class="group-image">
                          <img :src="imageUrl" :alt="imageKey" />
                        </div>
                      </label>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label">Group Type</label>
                    <input
                      v-if="is_edit"
                      v-model="pre.groupTypes[value.group_type]"
                      id="group_type"
                      name="group_type"
                      class="form-control group_type"
                      readonly
                    />
                    <!-- <multiselect
                      v-else
                      v-model="value.group_type"
                      :options="Object.keys(pre.groupTypes)"
                      :custom-label="(opt) => pre.groupTypes[opt]"
                      placeholder="Select Group Name"
                      :searchable="true"
                      :multiple="false"
                      id="group_type"
                      v-bind:class="{ 'has-error': errors.has('group_type') }"
                      name="group_type"
                    >
                    </multiselect> -->
                    <div v-else class="d-flex" style="flex-wrap: wrap; gap: 10px">
                      <label
                        class="radio mr-3"
                        v-for="(group_type, index) in Object.keys(pre.groupTypes)"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :value="group_type"
                          v-model="value.group_type"
                          name="group_type"
                          id="group_type"
                          v-validate="'required'"
                          :checked="group_type === 'DEFAULT'"
                        />
                        <span class="radio-mark"></span>{{ pre.groupTypes[group_type] }}
                      </label>
                    </div>
                  </div>

                  <div
                    v-if="value.group_type && value.group_type != 'DEFAULT'"
                    class="form-group"
                  >
                    <label class="control-label">{{
                      pre.contentsLabel[value.group_type]
                    }}</label>
                    <textarea
                      type="textarea"
                      id="contents"
                      name="contents"
                      v-bind:class="{ 'has-error': errors.has('contents') }"
                      v-model="value.contents"
                      class="form-control contents"
                      :placeholder="pre.contentsPlaceholder[value.group_type]"
                      row="3"
                    >
                    </textarea>
                    <div class="help text-danger" v-show="errors.has('contents')">
                      {{ errors.first("contents") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "GroupInfoForm",
  metaInfo: {
    title: "Group Info | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    groupImage: "",

    value: {
      group_type: "DEFAULT",
    },
    pre: {
      audraName: [],
      groupTypes: {
        DEFAULT: "DEVICE GROUP",
        IP: "IP GROUP",
        DOMAIN: "DOMAIN GROUP",
        PORT: "PORT GROUP",
      },
      contentsLabel: {
        IP: "IP Address(s)",
        DOMAIN: "Domain Name(s)",
        PORT: "Port Number(s)",
      },
      contentsPlaceholder: {
        IP:
          "Input IP address as comma separated. Example : 192.168.20.100,192.168.20.101 .......",
        DOMAIN:
          "Input domain address as comma separated. Example : www.abc.com,www.ssd-tech.io,.......",
        PORT: "Input port numbers as comma separated. Example : 80,90,.......",
      },
      groupImages: {
        "group-devices": "/assets/images/group-devices.svg",
        "group-gaming": "/assets/images/group-gaming.svg",
        "group-lamp": "/assets/images/group-lamp.svg",
        "group-plant": "/assets/images/group-plant.svg",
        "group-store": "/assets/images/group-store.svg",
        "group-upload": "/assets/images/group-upload.svg",
        "group-guest": "/assets/images/group-guest.svg",
        "group-children": "/assets/images/group-children.svg",
        "group-mygroup": "/assets/images/group-mygroup.svg",
        "group-inactive": "/assets/images/group-inactive.svg",
        "group-employee": "/assets/images/group-employee.svg",
        "group-management": "/assets/images/group-management.svg",
      },
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/group_info";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/group_info/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "GroupInfoList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/group_info/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back();
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
